(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["running-banner"] && !Shopify.designMode) return;
  try {
    
  class RunningBanner extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-running-banner-track]');
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';

      if (this.pauseOnHover) {
        this.setupHoverPause();
      }
    }

    setupHoverPause() {
      this.addEventListener('mouseenter', () => {
        this.track.style.animationPlayState = 'paused';
      });

      this.addEventListener('mouseleave', () => {
        this.track.style.animationPlayState = 'running';
      });
    }
  }

  if (!customElements.get('running-banner')) {
    customElements.define('running-banner', RunningBanner);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-section-type="running-banner"]')) {
      const section = event.target.querySelector('running-banner');
      if (section && !customElements.get('running-banner')) {
        customElements.define('running-banner', RunningBanner);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
